import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import Image from "next/image";

const Features_carousel = ({drawerItems}) => {
  return (
    <>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        loop={true}
        slidesPerView={'auto'}
        autoplay={{
          delay: 2000,
        }}
        breakpoints={{
          1440: {
            slidesPerView: 3.5,
          },
          1024: {
            slidesPerView: 2.5,
          },
          375: {
            slidesPerView: 1.5,
          },
        }}
        pagination={{ clickable: true }}
        className="!py-5 !overflow-visible"
      >
        {drawerItems?.map((item) => {
          const { id, img, title, desc } = item;
          return (
            <SwiperSlide className="text-white" style={{height: 'auto'}} key={id}>
              <div style={{height: 'calc(100% - 20px)'}} className="rounded-2.5xl bg-jacarta-800 p-10">
                <div className="mb-4 md:mb-0">
                  <figure className="mb-8">
                    <Image src={img} alt="" height={48} width={48} />
                  </figure>
                  <h3 className="mb-4 font-display text-lg text-white">
                    {title}
                  </h3>
                  <p className="text-jacarta-300">{desc}</p>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default Features_carousel;
